import { SET_CONTACT_REQUESTED, SET_CONTACT_COMPLETED } from './types';

const selectContactAction = (ContactID) => (dispatch, getState) => {
  dispatch({
    type: SET_CONTACT_REQUESTED,
  });
  const { contacts } = getState();

  const contactsitems = contacts.get('list');

  const payload = (contactsitems?.items ?? []).find(
    (item) =>
      (item?.ContactID ?? '')?.toLowerCase() === ContactID.toLowerCase(),
  );

  dispatch({
    type: SET_CONTACT_COMPLETED,
    payload,
  });
};

export default selectContactAction;
